module.exports = __webpack_public_path__ + "dc8fa6a4477ab1bccdf5c3e53b97a6ba.pdf";